/* External */
import { memo } from 'react';

/* Ott-common */
import { useLiveProgress } from '@dtvgo/player-utils-react';

/* Components */
import CurrentTime from './CurrentTime';

function LiveCurrentTime() {
  return <CurrentTime progress={useLiveProgress()} />;
}

export default memo(LiveCurrentTime);
